var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "postcode-lookup" }, [
    !_vm.dropdownOpen
      ? _c("div", { staticClass: "postcode-lookup__intro" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "step__form--question",
                attrs: { for: "lookupAddress" },
              },
              [
                _vm._v("\n                Billing address*\n                "),
                _vm.searching
                  ? _c("span", [
                      _vm._v(
                        "\n                    Searching...\n                "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row postcode-lookup__container" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-8",
                  class: {
                    "form-group--error": _vm.$v.value.lookupAddress.$error,
                  },
                },
                [
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", id: "lookupAddress" },
                    domProps: { value: _vm.value.lookupAddress },
                    on: {
                      input: function ($event) {
                        return _vm.updateValue(
                          "lookupAddress",
                          $event.target.value
                        )
                      },
                      keydown: _vm.debouncedToggleFindAddress,
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.value.lookupAddress.required
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("Please specify this information"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.clusters.length
                      ? _c(
                          "ul",
                          { staticClass: "postcode-lookup__clusters" },
                          _vm._l(_vm.clusters, function (cluster) {
                            return _c("li", { key: cluster.id }, [
                              cluster.type === "Address"
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "postcode-lookup__individual",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleRetrieveAddress(
                                            cluster.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(cluster.text) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "postcode-lookup__group",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleFindAddress(
                                            cluster.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(cluster.text) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-4 postcode-lookup__link-container",
                },
                [
                  !_vm.dropdownOpen
                    ? _c(
                        "a",
                        {
                          staticClass: "postcode-lookup__link",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toggleDropdown.apply(null, arguments)
                            },
                          },
                        },
                        [_c("strong", [_vm._v("Add address manually")])]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.dropdownOpen
      ? _c("div", { staticClass: "postcode-lookup__dropdown" }, [
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "form-group--error": _vm.$v.value.addressLine1.$error },
            },
            [
              _c(
                "label",
                {
                  staticClass: "step__form--question",
                  attrs: { for: "address1" },
                },
                [_vm._v("Billing address - line 1*")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", id: "address1" },
                domProps: { value: _vm.value.addressLine1 },
                on: {
                  input: function ($event) {
                    return _vm.updateValue("addressLine1", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              !_vm.$v.value.addressLine1.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Please specify this information"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "step__form--question",
                attrs: { for: "address2" },
              },
              [_vm._v("Billing address - line 2")]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "address2" },
              domProps: { value: _vm.value.addressLine2 },
              on: {
                input: function ($event) {
                  return _vm.updateValue("addressLine2", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "step__form--question",
                attrs: { for: "address3" },
              },
              [_vm._v("Billing address - line 3")]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "address3" },
              domProps: { value: _vm.value.addressLine3 },
              on: {
                input: function ($event) {
                  return _vm.updateValue("addressLine3", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "form-group--error": _vm.$v.value.city.$error },
            },
            [
              _c(
                "label",
                { staticClass: "step__form--question", attrs: { for: "city" } },
                [_vm._v("City*")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", id: "city" },
                domProps: { value: _vm.value.city },
                on: {
                  input: function ($event) {
                    return _vm.updateValue("city", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              !_vm.$v.value.city.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Please specify this information"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "step__form--question",
                attrs: { for: "province" },
              },
              [_vm._v("County")]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", id: "province" },
              domProps: { value: _vm.value.province },
              on: {
                input: function ($event) {
                  return _vm.updateValue("province", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group",
              class: { "form-group--error": _vm.$v.value.postcode.$error },
            },
            [
              _c(
                "label",
                {
                  staticClass: "step__form--question",
                  attrs: { for: "postcode" },
                },
                [_vm._v("Post code*")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", id: "postcode" },
                domProps: { value: _vm.value.postcode },
                on: {
                  input: function ($event) {
                    return _vm.updateValue("postcode", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              !_vm.$v.value.postcode.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Please specify this information"),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }